export const TIME_FOR_UPDATE_QR = 5000;
